import LiveFeedCard from './LiveFeedCard/LiveFeedCard';
import StatsCard from './StatsCard/StatsCard';
import { useScreenSize } from '@/hooks';
import styles from './WelcomeBannerRightPanel.module.css';

const WelcomeBannerRightPanel = () => {
  const { isMobile, isTablet } = useScreenSize();
  const isMobileOrTablet = isMobile || isTablet;

  return (
    <div className={styles.panel}>
      <LiveFeedCard />
      {!isMobileOrTablet && <StatsCard />}
      
    </div>
  );
};

export default WelcomeBannerRightPanel;
